import React, { useEffect, useState } from 'react';
import { Row, Col, Container, Table } from 'react-bootstrap';
import { getInventoryReports } from '../../services/Reports/Reports';
import { getCategories } from '../../services/Configs/ItemCategoriesService';
import { getAllSubCategories } from '../../services/Configs/ItemSubCategoriesService';
import { getStatuses } from '../../services/Other/GeneralQueries';
import { PDFLink } from './RequestReport';
import Loading from '../../components/Layout/Loading';

const Reports = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [status, setStatuses] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [selectedSubcategory, setSelectedSubcategory] = useState(0);
  const [selectedStatuses, setSelectedStatuses] = useState(0);
  const [inventory, setInventory] = useState([]);

  useEffect(() => {    
    getStatuses().then((data) => {
      setStatuses(data);
    });
    getCategories().then((data) => {
      setCategories(data);
    });
    getInventoryReports(selectedCategory, selectedSubcategory, selectedStatuses).then((data) => {
      setInventory(data);
    }).finally(()=> {
      setIsLoading(false)  
    })      
}, []);



const loadSubcategory = async (e) => {
  let { value } = e.target;    
  setSelectedCategory(value); // Siempre actualiza la categoría seleccionada
  if (value == 0) {
    setSubCategories([]);
    setSelectedSubcategory(0);
  }
};


useEffect(() => {
  setIsLoading(true);
  setInventory([]);
  getAllSubCategories(selectedCategory).then((data) => {
    setSubCategories(data);
    setIsLoading(true);
  }).then(() => {
    getInventoryReports(selectedCategory, selectedSubcategory, selectedStatuses).then((data) => {
      setInventory(data);
      setIsLoading(false);
    })

  })    
}, [selectedCategory, selectedSubcategory, selectedStatuses]);

  return (
    <div>
      <h1>Reports</h1>

      <Row>
        <Col xl={2}> 
        <b>Categorías</b>
          <select onChange={loadSubcategory} className="form-control mt-2" style={{ width: 'auto' }}>
            <option value={0}>Todas las categorías</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </Col>
        <Col xl={2}> 
        <b>Subcategorías</b>
          <select onChange={(e) => setSelectedSubcategory(e.target.value)} className="form-control mt-2" style={{ width: 'auto' }}>
            <option value={0}>Todas las subcategorías</option>
            {subCategories.map((subCategory) => (
              <option key={subCategory.id} value={subCategory.id}>
                {subCategory.name}
              </option>
            ))}
          </select>
        </Col>
        <Col xl={2}> 
        <b>Estados</b>
          <select onChange={(e) => setSelectedStatuses(e.target.value)} className="form-control mt-2" style={{ width: 'auto' }}>
            <option value={0}>Todos los estados</option>
            {status.map((statusItem) => (
              <option key={statusItem.id} value={statusItem.id}>
                {statusItem.name}
              </option>
            ))}
          </select>
        </Col>
        <Col xl={6}> 
        </Col>
      </Row>

      {inventory.length > 0 &&
        <div style={{ marginBottom: '10px', textAlign: "center" }}>
          <PDFLink data={inventory} />
        </div>
      }
      {
        inventory.length == 0 ?
        <div className='row mt-3'>
          <div className='col-xl-12 text-center'>
            <h3>No hay objetos en los filtros seleccionados</h3>
          </div>
        </div> : 
         <Container fluid>
          {
            isLoading ?
            <Loading /> :
          <Table striped bordered hover responsive >
            <thead style={{ backgroundColor: '#01579b', color: "white" }}>
              <tr>
                <th style={{ fontWeight: 'bold', textAlign: 'center' }}>Nombre</th>
                <th style={{ fontWeight: 'bold', textAlign: 'center' }}>Descripción</th>
                <th style={{ fontWeight: 'bold', textAlign: 'center' }}>Categoría</th>
                <th style={{ fontWeight: 'bold', textAlign: 'center' }}>Subcategoría</th>
                <th style={{ fontWeight: 'bold', textAlign: 'center' }}>Cantidad</th>
                <th style={{ fontWeight: 'bold', textAlign: 'center' }}>Ubicación</th>
                <th style={{ fontWeight: 'bold', textAlign: 'center' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {
                inventory && inventory.length > 0 ?
                  inventory.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#cce6ff'
                      }}
                    >
                      <td style={{ textAlign: 'left', fontSize: '16px', textTransform: 'capitalize' }}>{item.name}</td>
                      <td style={{ textAlign: 'left', fontSize: '16px', textTransform: 'capitalize' }}>{item.description}</td>
                      <td style={{ textAlign: 'center', fontSize: '16px' }}>{item.categoryName}</td>
                      <td style={{ textAlign: 'center', fontSize: '16px' }}>{item.subcategoryName}</td>
                      <td style={{ textAlign: 'center', fontSize: '16px' }}>{item.quantity}</td>
                      <td style={{ textAlign: 'center', fontSize: '16px' }}>{item.locationName}</td>
                      <td style={{ textAlign: 'center', fontSize: '16px' }}>{item.statusName}</td>
                    </tr>
                  )) : null
              }
            </tbody>
          </Table>
          }
         
       </Container>
      }
     
    </div>
  );
};

export default Reports;